export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8260.873d4e85.jpg";